'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/aframe-react/~/react/react.js
// module id = 224
// module chunks = 0